import { Container, LoadingScreen } from '@/shared/components'
import useI18n from '@/shared/hooks/usei18n'
import { useSession } from '@/shared/hooks/useSession'
import { useGetOrganizationUsers, OrganizationUser } from '@/features/organization/hooks/users'
import { H2, PageSection } from '@/common'
import useDialog from '@/common/hooks/useDialog'
import { Route } from 'react-router-dom'
import { Routes } from 'react-router-dom'
import { useState } from 'react'
import EditPermissionsDialog from './dialogs/EditPermissionsDialog'
import UserManagementList from './components/UserManagementList'

export default function UserManagement() {
  return (
    <Routes>
      <Route path="/" element={<UserManagementPage />} />
    </Routes>
  )
}

function UserManagementPage() {
  const { session } = useSession()
  const { t } = useI18n()

  const organizationId = session.organization.id
  const usersQuery = useGetOrganizationUsers(organizationId)

  const {
    open: isEditPermissionsDialogOpen,
    openDialog: openEditPermissionsDialog,
    closeDialog: closeEditPermissionsDialog
  } = useDialog()

  const [selectedUserId, setSelectedUserId] = useState<string | null>(null)

  const isLoadingUsers = usersQuery.isLoading
  const users = usersQuery.data || []

  const selectedUser = selectedUserId
    ? users.find(user => user.id === selectedUserId) || null
    : null

  const handleEditPermissions = (user: OrganizationUser) => {
    setSelectedUserId(user.id)
    openEditPermissionsDialog()
  }

  // Clear selectedUserId when dialog closes
  const handleCloseDialog = () => {
    closeEditPermissionsDialog()
    setSelectedUserId(null)
  }

  if (isLoadingUsers) {
    return <LoadingScreen />
  }

  return (
    <Container>
      <header>
        <H2>{t('userManagement:title')}</H2>
      </header>
      <PageSection title={t('userManagement:usersSection.title')}>
        <UserManagementList
          users={users}
          isSessionUserAdmin={session.role === 'ADMIN'}
          onEditPermissions={handleEditPermissions}
          handleEditPermissions={handleEditPermissions}
        />
      </PageSection>
      <EditPermissionsDialog
        isOpen={isEditPermissionsDialogOpen}
        close={handleCloseDialog}
        user={selectedUser}
      />
    </Container>
  )
}
